import RoutesHelper from 'helpers/RoutesHelper'
import * as types from 'remote/notifications/types'
import history from 'browserHistory'
import { acknowledgeNotifications } from 'data/notifications/actions'

import { setActiveModal } from 'data/ui/actions'
import { CHANNEL_SETTINGS } from 'components/Utils/Modal/constants'
import { COMMENTS } from '../ui/UrlPanelTypes'

const wrapAknowledgementOnNavigate = navigate => (dispatch, notification) => {
  navigate(dispatch, notification)
  dispatch(acknowledgeNotifications(({ id }) => notification.id === id))
}

const noteUrlFromNotification = metadata => {
  const { channelId, noteId, threadId, commentId } = metadata.toJS()
  return channelId
    ? RoutesHelper.noteChannelShow({
        channelId,
        noteId,
        options: threadId ? COMMENTS : null,
        threadId,
        commentId,
      })
    : RoutesHelper.noteShow({
        noteId,
        options: threadId ? COMMENTS : null,
        threadId,
        commentId,
      })
}

export const settingsMap = {
  [types.ADD_USER_TO_CHANNEL]: {
    getTitle: metadata => metadata.get('channelName'),
    getBody: metadata =>
      `${metadata.get('authorName')} added you to the channel "${metadata.get(
        'channelName'
      )}"`,
    actionLabel: 'Go to channel',
    navigate: wrapAknowledgementOnNavigate((dispatch, notification) => {
      const { channelId } = notification.metadata.toJS()
      history.push(
        RoutesHelper.noteChannelIndex({
          channelId,
        })
      )
    }),
  },
  [types.UPDATE_USER_ROLES_ON_CHANNEL]: {
    getTitle: metadata => metadata.get('channelName'),
    getBody: metadata =>
      `${metadata.get('authorName')} made you a ${metadata.get(
        'role'
      )} of "${metadata.get('channelName')}"`,
    actionLabel: 'Go to channel',
    navigate: wrapAknowledgementOnNavigate((dispatch, notification) => {
      const { channelId } = notification.metadata.toJS()
      history.push(
        RoutesHelper.noteChannelIndex({
          channelId,
        })
      )
    }),
  },
  [types.ADD_THREAD_TO_NOTE]: {
    getTitle: metadata => metadata.get('noteTitle') || 'New comment',
    getBody: metadata =>
      `${metadata.get('authorName')} wrote a comment on the doc ${metadata.get(
        'noteTitle'
      )} : "${metadata.get('excerpt')}..."`,
    actionLabel: 'View comment',
    navigate: wrapAknowledgementOnNavigate((dispatch, notification) => {
      history.push(noteUrlFromNotification(notification.metadata))
    }),
  },
  [types.MENTION_IN_COMMENT]: {
    getTitle: metadata => metadata.get('noteTitle') || 'Mention',
    getBody: metadata =>
      `${metadata.get(
        'authorName'
      )} mentioned you in a comment on the doc ${metadata.get(
        'noteTitle'
      )} : "${metadata.get('excerpt')}..."`,
    actionLabel: 'View comment',
    navigate: wrapAknowledgementOnNavigate((dispatch, notification) => {
      history.push(noteUrlFromNotification(notification.metadata))
    }),
  },
  [types.REPLY_TO_COMMENT]: {
    getTitle: metadata => metadata.get('noteTitle') || 'Reply',
    getBody: metadata =>
      `${metadata.get(
        'authorName'
      )} replied to one of your comment on the doc ${metadata.get(
        'noteTitle'
      )} : "${metadata.get('excerpt')}..."`,
    actionLabel: 'View reply',
    navigate: wrapAknowledgementOnNavigate((dispatch, notification) => {
      history.push(noteUrlFromNotification(notification.metadata))
    }),
  },
  [types.NUDGE_ABOUT_NOTE]: {
    getTitle: metadata => metadata.get('noteTitle') || 'Ping',
    getBody: metadata =>
      `${metadata.get(
        'authorName'
      )} wants your attention on the "${metadata.get('noteTitle')}" doc`,
    actionLabel: 'View doc',
    navigate: wrapAknowledgementOnNavigate((dispatch, notification) => {
      history.push(noteUrlFromNotification(notification.metadata))
    }),
  },
  [types.MENTION_IN_NOTE]: {
    getTitle: metadata => metadata.get('noteTitle') || 'Mention',
    getBody: metadata => {
      // In case note activity has multiple user we don't know the exact mention author
      // the notification is modify in consequence
      const knownAuthor = metadata.get('authorName') !== 'Someone'
      return knownAuthor
        ? `${metadata.get('authorName')} mentioned you in the "${metadata.get(
            'noteTitle'
          )}" doc`
        : `You've been mentioned in the "${metadata.get('noteTitle')}" doc`
    },
    actionLabel: 'View doc',
    navigate: wrapAknowledgementOnNavigate((dispatch, notification) => {
      history.push(noteUrlFromNotification(notification.metadata))
    }),
  },
  [types.REQUEST_CHANNEL_ACCESS]: {
    getTitle: metadata =>
      metadata.get('channelName') || 'Channel Access Request',
    getBody: metadata =>
      `${metadata.get('authorName')} request access to the "${metadata.get(
        'channelName'
      )}" channel`,
    actionLabel: `Go to channel's settings`,
    navigate: wrapAknowledgementOnNavigate((dispatch, notification) => {
      const { channelId } = notification.metadata.toJS()
      history.push(RoutesHelper.channelShow({ channelId }))
      dispatch(
        setActiveModal({
          id: CHANNEL_SETTINGS,
          meta: {
            channelId,
            defaultTabId: 'users',
          },
        })
      )
    }),
  },
  [types.REQUEST_NOTE_ACCESS]: {
    getTitle: metadata => metadata.get('noteTitle') || 'Doc Access Request',
    getBody: metadata =>
      `${metadata.get('authorName')} request access to the "${metadata.get(
        'noteTitle'
      )}" doc`,
    actionLabel: `Go to channel's settings`,
    navigate: wrapAknowledgementOnNavigate((dispatch, notification) => {
      const { channelId } = notification.metadata.toJS()
      history.push(RoutesHelper.channelShow({ channelId }))
      dispatch(
        setActiveModal({
          id: CHANNEL_SETTINGS,
          meta: {
            channelId,
            defaultTabId: 'users',
          },
        })
      )
    }),
  },
}

export function getNotificationSettings(type) {
  const settings = settingsMap[type]
  if (!settings && window.bugsnag) {
    window.bugsnag.notify(
      new Error(`Unable to find a notification setting for type ${type}`)
    )
  }
  return settings
}

export function getNotificationNavigate(type) {
  const { navigate } = getNotificationSettings(type)
  return navigate
}
